import { useCallback } from "react";
import _ from "lodash";

import { format, FORMATS } from "utils/datetime";

import Button from "components/Button";
import PageHeader from "components/PageHeader";
import Stack from "components/Stack";
import toast from "components/Toast";

import CustomReportExportButton from "entities/Reporting/components/CustomReportExportButton";
import FiltersButton from "entities/Reporting/components/FiltersButton";
import ReportSearchField from "entities/Reporting/components/ReportSearchField";
import SelectedFilters from "entities/Reporting/components/SelectedFilters";
import {
  INonPipelineColumns,
  ISimpleReportPackage,
  reportPackageDetailsInvalidateCache,
} from "entities/Reporting/sdk";

export interface ICustomReportPageHeader {
  reportPackage: ISimpleReportPackage;
  rows: { [key: string]: string | null }[];
  columns: INonPipelineColumns[];
  loading: boolean;
  latestRowUpdateDateTime: string | undefined;
}

const CustomReportPageHeader = ({
  reportPackage,
  rows,
  columns,
  loading,
  latestRowUpdateDateTime,
}: ICustomReportPageHeader) => {
  const onUpdate = useCallback(() => {
    reportPackageDetailsInvalidateCache({
      reportPackageId: reportPackage.id,
    }).then(() => {
      toast.successMessage("Report will be updated shortly.");
    });
  }, [reportPackage]);

  return (
    <>
      <PageHeader
        title={reportPackage.name}
        subTitle={
          loading || _.isNil(latestRowUpdateDateTime) ? (
            "Loading..."
          ) : (
            <Stack direction="row" paddingTop={0.5} alignItems="center">
              Latest update:{" "}
              {format(
                new Date(latestRowUpdateDateTime),
                FORMATS.FRONTEND.DATETIME
              )}
              <Button
                size="small"
                variant="outlined"
                sx={{ marginLeft: 2 }}
                onClick={onUpdate}
              >
                Update
              </Button>
            </Stack>
          )
        }
        actions={
          <Stack
            spacing={2}
            direction="row"
            sx={{ flex: 1 }}
            justifyContent="flex-end"
          >
            <ReportSearchField placeholder="Search by deal name" />
            <FiltersButton
              columns={columns}
              reportPackageId={reportPackage.id}
              disabled={rows.length === 0 && loading}
              rows={rows}
              filtersButtonDataTestid="filter-deals-button"
            />
            <CustomReportExportButton
              reportPackage={reportPackage}
              rows={rows}
              columns={columns}
            />
          </Stack>
        }
      />
      <SelectedFilters
        columns={columns}
        reportPackageId={reportPackage.id}
        isHardcodedReport={false}
      />
    </>
  );
};
export default CustomReportPageHeader;
